import { useRef, useEffect, useReducer } from 'react'
import classNames from 'classnames'
import { HIRAGANA_SETS, KATAKANA_SETS } from './kana'
import { ButtonUI, CardUI } from './App.styles'
import { getAllKanaFromSets, kanaPracticeReducer, getTimeSpan } from './utils'

export default function KanaPractice({ sets, setPage, mode }) {
  const inputRef = useRef(null)
  const availableKana = getAllKanaFromSets(sets)
  const [state, dispatch] = useReducer(kanaPracticeReducer, {
    cardSide: 'question',
    streak: 0,
    missed: 0,
    inputValue: '',
    history: [],
    currentKana: undefined,
    answered: 'no',
    startTime: null,
    endTime: null,
  })

  useEffect(() => {
    dispatch({
      type: 'CHOOSE_FIRST_KANA',
      payload: { availableKana },
    })
    inputRef.current?.focus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!state.finishedRun || state.cardSide === 'question') {
      inputRef.current?.focus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.finishedRun, state.cardSide])

  function renderCardContent() {
    if (state.currentKana == null) return null
    if (state.cardSide === 'question') {
      return state.currentKana[0]
    }
    return state.currentKana[1]
  }

  return (
    <>
      <h1>
        {!!sets.find((set) => Object.keys(HIRAGANA_SETS).includes(set)) &&
          'Hiragana'}{' '}
        {!!sets.find((set) => Object.keys(KATAKANA_SETS).includes(set)) &&
          'Katakana'}{' '}
        to Rōmaji
      </h1>
      {state.cardSide === 'question' && !state.finishedRun && (
        <input
          type="text"
          name="your-answer"
          id="your-answer"
          value={state.inputValue}
          ref={inputRef}
          onChange={(e) =>
            dispatch({
              type: 'INPUT_CHANGE',
              payload: { inputValue: e.target.value },
            })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const { value } = e.target

              if (!value) return
              if (value.toLowerCase() === state.currentKana[1]) {
                dispatch({
                  type: 'ENTER_CORRECT',
                  payload: { availableKana, mode },
                })
              } else {
                dispatch({
                  type: 'ENTER_WRONG',
                })
              }
            }
          }}
        />
      )}
      {state.cardSide === 'answer' && (
        <ButtonUI
          className="next-one"
          onClick={() => {
            dispatch({
              type: 'NEXT_KANA',
              payload: { availableKana, mode },
            })
          }}
        >
          Next one
        </ButtonUI>
      )}
      {!state.finishedRun ? (
        <CardUI
          className={classNames('CardUI', `answered-${state.answered}`)}
          onClick={(e) => {
            dispatch({ type: 'FLIP' })
          }}
        >
          {renderCardContent()}
        </CardUI>
      ) : (
        <div>
          <div>Finished all of them, well done!</div>
          <br />
          <div>
            Took you: {getTimeSpan(state.startTime, state.endTime).minutes}{' '}
            minutes {getTimeSpan(state.startTime, state.endTime).seconds}{' '}
            seconds
          </div>
          <ButtonUI
            className="restart"
            onClick={() => {
              dispatch({
                type: 'CHOOSE_FIRST_KANA',
                payload: { availableKana },
              })
            }}
          >
            Restart
          </ButtonUI>
        </div>
      )}
      <div className="info-box">
        <div className="info">
          Studying <strong>{availableKana.length}</strong> Kanas
        </div>
        <div className="info">
          Current streak: <strong>{state.streak}</strong>
        </div>
        <div className="info">
          Missed: <strong>{state.missed}</strong>
        </div>
        <div className="info">
          Answered: <strong>{state.history.length}</strong>
        </div>
        <div className="info">Mode: {mode === 'oneGo' ? 'One go' : mode}</div>
      </div>
      <ButtonUI
        className="go-back"
        onClick={() => {
          setPage('config')
        }}
      >
        Go back to options
      </ButtonUI>
    </>
  )
}
